import { FormLayout } from "../../../../layouts/form";
import { FormHelperText, Grid, TextField, Typography } from "@mui/material";
import InputSlider from "../../../../components/inputSlider";
import { useEffect, useState } from "react";
import { FormControl, OutlinedInput, MenuItem, Select, InputLabel } from "@mui/material";
import { NotificationManager } from "react-notifications";
import { CompaniesService } from "../../../../services/companies";
import { VehiclesService } from "../../../../services/vehicles";
import { useContext } from 'react';
import { AuthContext } from '../../../../contexts/auth';
import { TrackersService } from "../../../../services/trackers";

export const FarmForm = ({ onClose, defaultValues }) => {
    const companiesService = new CompaniesService();
    const vehicleService = new VehiclesService();
    const trackersService = new TrackersService();
    const [companies, setCompanies] = useState([]);
    const [blueprints, setBlueprints] = useState([]);
    const [saving, setSaving] = useState(false);
    const [disableSaving, setDisableSaving] = useState(false);
    const { userType, userCompanyId } = useContext(AuthContext);
    const [selectedCompanyId, setSelectedCompanyId] = useState();
    const [listVehicles, setListVehicle] = useState([]);
    const [selectBlueprint, setSelectBlueprint] = useState();

    const handleChange = (event) => {
        setSelectedCompanyId(event.target.value);
    }

    const handleChangeBlueprint = (event) => {
        setSelectBlueprint(event.target.value);
    }

    useEffect(() => {
        getVehicles();
        if (userType !== 'SystemAdmin') {
            let listBlueprints = [];
            companiesService.getCompany(userCompanyId).then(res => {
                const companiesList = [res.data];
                setCompanies(companiesList);
                res.data.blueprint.forEach((element, index) => {
                    listBlueprints.push({ value: element.toUpperCase(), id: index })
                });
                setBlueprints(listBlueprints);
            }).catch(err => {
            });
        } else {
        }
        setSelectedCompanyId(userCompanyId);
    }, []);

    const validateFields = (fields) => {
        const f = fields;

        if (f.name === "" ||
            f.model === "" ||
            f.temperatureIntThreshold === "" ||
            f.humidityThreshold === "" ||
            f.cO2Threshold === "") {
            NotificationManager.warning("Cadastro incompleto!", "", 3000);
            return false;
        } else {
            return true;
        }
    }

    const handleUpdateSuccess = () => {
        NotificationManager.success('Informações da granja atualizadas com sucesso.', "", 3000);
        setSaving(false);
        onClose();
    }

    const handleCreationSuccess = () => {
        NotificationManager.success('Granja criada com sucesso.', "", 3000);
        NotificationManager.warning('Vincule com um rastreador.', "", 3000);
        getVehicles();
        setSaving(false);
        onClose();
    }

    const getVehicles = () => {
        if (defaultValues) {
            vehicleService.getNotLinkedById(defaultValues.id)
                .then(response => {
                    if (response.data === false) {
                        setDisableSaving(true);
                        NotificationManager.warning('Vincule com um rastreador.', "", 3000);
                    } else {
                        setDisableSaving(false);
                    }
                }).catch(error => {
                    console.error(error);
            });
        }
    };

    const handleVehicleSave = (formData) => {

        var dataList = [];
        const data = new FormData(formData);
        const newVehicle = {
            "plate": data.get('platetf'),
            "model": data.get('modeltf'),
            "temperatureMaxThreshold": data.get('temperatureMaxThreshold'),
            "temperatureMinThreshold": data.get('temperatureMinThreshold'),
            "humidityMaxThreshold": data.get('humidityMaxThreshold'),
            "humidityMinThreshold": data.get('humidityMinThreshold'),
            "cO2MaxThreshold": data.get('cO2MaxThreshold'),
            "cO2MinThreshold": data.get('cO2MinThreshold'),
            "vibrationMaxThreshold": data.get('vibrationMaxThreshold'),
            "vibrationMinThreshold": data.get('vibrationMinThreshold'),
            "companyId": selectedCompanyId,
            "typeOperation": data.get('typeOperation'),
            "blueprint": data.get('blueprint')
        };

        if (!validateFields(newVehicle)) {
            setSaving(false);
            return;
        }
        setSaving(true);
        setDisableSaving(true);

        if (defaultValues) {
            newVehicle.id = defaultValues.id;
            var test = listVehicles.some(element => element.id === newVehicle.id);
            if (!test) {
                const newVehicleUpdate = {
                    "id": defaultValues.id,
                    "plate": data.get('platetf'),
                    "model": data.get('modeltf'),
                    "temperatureMaxThreshold": defaultValues.temperatureMaxThreshold,
                    "temperatureMinThreshold": defaultValues.temperatureMinThreshold,
                    "humidityMaxThreshold": defaultValues.humidityMaxThreshold,
                    "humidityMinThreshold": defaultValues.humidityMinThreshold,
                    "cO2MaxThreshold": defaultValues.cO2MaxThreshold,
                    "cO2MinThreshold": defaultValues.cO2MinThreshold,
                    "vibrationMaxThreshold": defaultValues.vibrationMaxThreshold,
                    "vibrationMinThreshold": defaultValues.vibrationMinThreshold,
                    "temperatureMaxThreshold_FormUpdate": data.get('temperatureMaxThreshold'),
                    "temperatureMinThreshold_FormUpdate": data.get('temperatureMinThreshold'),
                    "humidityMaxThreshold_FormUpdate": data.get('humidityMaxThreshold'),
                    "humidityMinThreshold_FormUpdate": data.get('humidityMinThreshold'),
                    "cO2MaxThreshold_FormUpdate": data.get('cO2MaxThreshold'),
                    "cO2MinThreshold_FormUpdate": data.get('cO2MinThreshold'),
                    "vibrationMaxThreshold_FormUpdate": data.get('vibrationMaxThreshold'),
                    "vibrationMinThreshold_FormUpdate": data.get('vibrationMinThreshold'),
                    "companyId": selectedCompanyId,
                    "typeOperation": defaultValues.typeOperation,
                    "blueprint": data.get('blueprint')
                };
                vehicleService.updateVehicle(newVehicleUpdate).then(() => {
                    dataList = {
                        Id: newVehicle.id,
                        Model: newVehicle.model,
                        Plate: newVehicle.plate,
                        TemperatureMaxThreshold_FormUpdate: newVehicle.temperatureMaxThreshold,
                        TemperatureMinThreshold_FormUpdate: newVehicle.temperatureMinThreshold,
                        HumidityMaxThreshold_FormUpdate: newVehicle.humidityMaxThreshold,
                        HumidityMinThreshold_FormUpdate: newVehicle.humidityMinThreshold,
                        CO2MaxThreshold_FormUpdate: newVehicle.cO2MaxThreshold,
                        CO2MinThreshold_FormUpdate: newVehicle.cO2MinThreshold,
                        VibrationMaxThreshold_FormUpdate: newVehicle.vibrationMaxThreshold,
                        VibrationMinThreshold_FormUpdate: newVehicle.vibrationMinThreshold,
                        CompanyId: newVehicle.companyId,

                        IsRemoved: false,
                    }
                    trackersService.uploadParm(dataList).then(() => {
                        handleUpdateSuccess();
                    }).catch((error) => {
                        console.error(error);
                        setSaving(false);
                        setDisableSaving(false);
                    })
                    handleUpdateSuccess();
                }).catch((error) => {
                    setSaving(false);
                setDisableSaving(false);
                });
            } else {
                NotificationManager.warning('Vincule com um rastreador.', "", 3000);
            }
        } else {
            const newVehicleCreated = {
                "plate": data.get('platetf'),
                "model": data.get('modeltf'),
                "temperatureMaxThreshold": 0,
                "temperatureMinThreshold": 0,
                "humidityMaxThreshold": 0,
                "humidityMinThreshold": 0,
                "cO2MaxThreshold": 0,
                "cO2MinThreshold": 0,
                "vibrationMaxThreshold": 0,
                "vibrationMinThreshold": 0,
                "companyId": selectedCompanyId,
                "typeOperation": "",
                "blueprint": selectBlueprint
            };
            vehicleService.createVehicle(newVehicleCreated).then((res) => {
                handleCreationSuccess();
            }).catch((error) => {
                setSaving(false);
                setDisableSaving(false);
            });
        }
    }

    const formatInput = (event) => {
        let temp = event.target.value;
        temp = temp.trim();
        event.target.value = temp;
    }

        const inputPropsTextFiel = {
        style: {
            height: 20
        }
    }

    return (
        <FormLayout onSaveClick={handleVehicleSave} saving={saving} disableButton={disableSaving}>
            <Grid container spacing={2}>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid item xs={4} marginTop="20px">
                        <TextField
                            id="platetf"
                            defaultValue={defaultValues && defaultValues.plate}
                            name="platetf"
                            label="Granja"
                            fullWidth
                            variant="outlined"
                            required
                            onBlur={formatInput}
                            size="small"
                            style={{
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                                width: 265,
                            }}
                            inputProps={{
                                maxlength: "14",
                                style: {
                                    height: 20
                                }
                            }}
                        />
                        <FormHelperText style={{ marginLeft: '5px', fontSize: '12px' }}>Máximo de 14 caracteres</FormHelperText>
                    </Grid>
                    <Grid item xs={4} marginLeft="35px">
                        <TextField
                            id="modeltf"
                            defaultValue={defaultValues && defaultValues.model}
                            name="modeltf"
                            label="Sala"
                            fullWidth
                            variant="outlined"
                            required
                            inputProps={inputPropsTextFiel}
                            onBlur={formatInput}
                            size="small"
                            style={{
                                boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                borderRadius: '6px',
                                width: 265
                            }}
                        />
                    </Grid>
                    <Grid item xs={4} marginLeft="35px">
                        <FormControl sx={{ width: 265 }}>
                            <InputLabel htmlFor="company-select-id-label">Empresa</InputLabel>
                            <Select
                                labelId="company-select-id-label"
                                name="companyId"
                                defaultValue={defaultValues ? defaultValues.companyId : userCompanyId}
                                input={<OutlinedInput label="Empresa" />}
                                onChange={handleChange}
                                style={{
                                    height: 36,
                                    boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                                    borderRadius: '6px',
                                }}
                            >
                                {companies.map(c => {
                                    return <MenuItem value={c.id}>{c.name}</MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid item xs={6}>
                        <TextField id="typeOperation"
                        defaultValue={!defaultValues ? " " : defaultValues.typeOperation}
                        name="typeOperation"
                        label="Tipo de operação"
                        fullWidth
                        variant="outlined"
                        disabled={true}
                        inputProps={inputPropsTextFiel}
                        size="small"
                        style={{
                            boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                            borderRadius: '6px',
                            width: 410
                        }} />
                    </Grid>
                    <Grid item xs={6} marginLeft="45px">
                        <FormControl>
                            <InputLabel htmlFor="blueprint-select-id-label" size="small" required>Plantas</InputLabel>
                            <Select
                                required
                                labelId="blueprint-select-id-label"
                                name="blueprint"
                                defaultValue={defaultValues ? defaultValues.blueprint : ""}
                                input={<OutlinedInput label="Planta" />}
                                onChange={handleChangeBlueprint}
                                style={{
                                    height: 36,
                                    width: 410,
                            boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
                            borderRadius: '6px',
                        }}
                            >
                                {blueprints.map(c => {
                                    return <MenuItem value={c.value}>{c.value}</MenuItem>
                                })}

                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">Limiares</Typography>
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Temperatura Interna Inferior (°C)"
                        name='temperatureMinThreshold'
                        startValue={defaultValues ? defaultValues.temperatureMinThreshold : 0}
                        min={0.0}
                        max={100.0}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Temperatura Interna Superior (°C)"
                        name='temperatureMaxThreshold'
                        startValue={defaultValues ? defaultValues.temperatureMaxThreshold : 0}
                        min={0.0}
                        max={100.0}
                        step={0.1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Umidade Inferior (%)"
                        name='humidityMinThreshold'
                        startValue={defaultValues ? defaultValues.humidityMinThreshold : 0}
                        min={0}
                        max={100}
                        step={1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="Umidade Superior (%)"
                        name='humidityMaxThreshold'
                        startValue={defaultValues ? defaultValues.humidityMaxThreshold : 0}
                        min={0}
                        max={100}
                        step={1}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="CO2 Inferior (PPM)"
                        name='cO2MinThreshold'
                        startValue={defaultValues ? defaultValues.cO2MinThreshold : 0}
                        min={0}
                        max={10000}
                        step={100}
                        disable={defaultValues ? false : true}
                    />
                </Grid>
                <Grid item xs={6}>
                    <InputSlider
                        label="CO2 Superior (PPM)"
                        name='cO2MaxThreshold'
                        startValue={defaultValues ? defaultValues.cO2MaxThreshold : 0}
                        min={0}
                        max={10000}
                        step={100}
                        disable={defaultValues ? false : true}
                    />
                </Grid>


            </Grid>
        </FormLayout>
    );
}